import { useLayoutEffect, useState } from 'react'
import { useWindowSize } from '.'
import { BlanketRect } from '../components'

const EMPTY_RECT: BlanketRect = {
    anchorTop: 0,
    anchorLeft: 0,
    height: 0,
    width: 0,
}

export const useBlanket = (
    open: boolean,
    contentRef: React.RefObject<HTMLDivElement>,
) => {
    const windowSize = useWindowSize()
    const [rect, setRect] = useState<BlanketRect>(EMPTY_RECT)

    useLayoutEffect(() => {
        if (!open) {
            setRect(EMPTY_RECT)
            return
        }

        const measure = () => {
            if (!contentRef.current) {
                return
            }
            const bounds = contentRef.current.getBoundingClientRect()
            setRect({
                anchorTop: bounds.top,
                anchorLeft: bounds.left,
                height: bounds.height,
                width: bounds.width,
            })
        }

        measure()
        // Remeasure after flex layout settles so the blanket fills the region.
        const rafId = window.requestAnimationFrame(measure)
        return () => window.cancelAnimationFrame(rafId)
    }, [open, windowSize, contentRef])

    return rect
}
